require("./lib/ads");
require("./lib/comments");
var paywall = require("./lib/paywall");
setTimeout(() => paywall(11003788), 3000);

var track = require("./lib/tracking");

require("component-responsive-frame/child");
